import { Action } from "@ngrx/store";
import { ReduxAction } from "./redux.action";
import {UserStaff} from "../models/user-staff.model";

export class SetOfficeStaffInfo implements ReduxAction {
  type: string = "SET_OFFICE_STAFF_INFO";
  officeStaff: UserStaff;

  constructor(officeStaff: UserStaff) {
    this.officeStaff = officeStaff;
  }

  get() {
    return this.officeStaff;
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/actions/office-staff.actions.ts